import { globalRef } from '@amazon/vinyl-util'
import { getPlaybackEnv, MetrixUploader } from '@amzn/bf-playback'
import { getPageForegroundSession, localStorageStore, pageLifecycle } from '@amzn/bf-playback/web'
import { webPlaybackAuth } from '@/auth/webPlaybackAuth'
import { createWebPlaybackDeviceProfile } from '@/device/webPlaybackDeviceProfile'
import { webPlaybackEndpoints } from '@/service/webPlaybackEndpoints'
import { isOnline } from '@/util/offlineUtil'

const UI_PENDING_METRIX_KEY = 'pendingMetrix.ui'

export const metrixUploaderRef = globalRef(
    () =>
        new MetrixUploader(
            {
                auth: webPlaybackAuth,
                device: createWebPlaybackDeviceProfile(() => getPlaybackEnv().device.deviceId),
                endpoints: webPlaybackEndpoints,
                lifecycle: pageLifecycle,
                network: {
                    get online$() {
                        return isOnline()
                    },
                },
                store: localStorageStore,
                session: {
                    get foregroundSessionId$() {
                        return getPageForegroundSession().id$
                    },
                },
            },
            { storageKey: UI_PENDING_METRIX_KEY }
        )
)

export function getMetrixUploader(): MetrixUploader {
    return metrixUploaderRef.value
}
